import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=27937c0a&scoped=true"
import script from "./Notification.js?vue&type=script&lang=js&external"
export * from "./Notification.js?vue&type=script&lang=js&external"
import style0 from "./Notification.scss?vue&type=style&index=0&id=27937c0a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27937c0a",
  null
  
)

export default component.exports